import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Lanterno. Nokto. Apoteko.</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Lanterno. Nokto. Apoteko. <br/>
        Sensenca kaj obtuza lum’. <br/>
        Vi vivu, peke aŭ sen peko – <br/>
        Sed restos sama vivresum’.
      </p>

      <p class="poem-block mb-3">
        Turniĝas cirklo triviala, <br/>
        Kaj post la mort’ denove ek: <br/>
        Glacia bril’ de l’ akv’ kanala. <br/>
        Lanterno. Nokto. Apotek’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Vulturo</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Vultur’ flugadas laŭ la rond’ <br/>
        Super herbejo kaj kabano, <br/>
        Spektante al dezerta mond’. <br/>
        Patrino ploras al infano: <br/>
        «Jen, prenu, pan’. Jen, suĉu, mam’. <br/>
        Humila estu por ĉiam».
      </p>

      <p class="poem-block mb-3">
        Tra la jarcentoj, tra la flam’, <br/>
        Tra sangribeloj, vin koncernaj, <br/>
        Vi restis sama, mia land’, <br/>
        Belec’ postplora kaj eterna. <br/>
        Ĝis kiam ploros la patrin’? <br/>
        Ĝis kiam bird’ timigos ŝin?
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Ne dormas oni, ne memoras…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ne dormas oni, ne memoras, <br/>
        Ne vendas. Super nigra strat’ <br/>
        Sonorilegoj ĝeme sonas, <br/>
        Turmentas nokton sen kompat’.
      </p>

      <p class="poem-block mb-3">
        Super kreaĵo de la homo, <br/>
        Kiun li pereigis mem, <br/>
        Super sufero, morto, vomo <br/>
        Sonoras paska rekviem’.
      </p>

      <p class="poem-block mb-3">
        Super vantec’ de l’ mond’ kruela, <br/>
        Kaj l’ sento, nesavebla jam. <br/>
        Sonoras super palt’ zibela, <br/>
        En kiu estis vi tiam.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Kiel penega estas la ekzist’…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Kiel penega estas la ekzist’ <br/>
        Inter vivantaj homoj – por neviva. <br/>
        Kaj pri tragikaj sentoj kun la trist’ <br/>
        Rakonto al la mens’ naiva!
      </p>

      <p class="poem-block mb-3">
        Kaj serĉ’ de l’ klaro en haosa noktfantom’, <br/>
        Ordigo de neordigita sentblizardo, <br/>
        Por ke laŭ pala respegul’ de l’ arto <br/>
        La mortbruligan vivon konu hom’!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Aleksandr Blok'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;